import { deleteChangeHostText } from 'Const/schedule-change-host/view';
import { useModal } from 'Store/modal';
import { useToast } from 'Store/toast';

const useDeleteConfirmationModal = () => {
  const { onOpenModal, onResetModal } = useModal();
  const { onOpenToast } = useToast();

  const openDeleteConfirmation = (onConfirm) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: deleteChangeHostText?.modalTilteText,
      contentDescription: deleteChangeHostText?.modalDescriptionText,
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: deleteChangeHostText?.primaryButtonModalText,
      secondaryButtonText: deleteChangeHostText?.secondaryButtonModalText,
      onClickPrimaryButton: () => {
        onConfirm();
        onResetModal();
        onOpenToast({
          description: deleteChangeHostText?.successDeleteText,
          status: 'success',
          duration: 5,
          position: 'top',
        });
      },
      onClickSecondaryButton: onResetModal,
    });
  };

  return { openDeleteConfirmation };
};

export default useDeleteConfirmationModal;
